import { createQueryKeys } from '@lukemorales/query-key-factory';
import { AxiosRequestConfig } from 'axios';
import { EQueryKeys } from 'common/enums/query-keys.enums.ts';
import { IWalletDataRes } from 'domains/wallet/inrefaces/wallet.interfaces.ts';
import { getWalletDataService } from 'domains/wallet/services/wallet.service.ts';

export const walletQueryKeys = createQueryKeys(EQueryKeys.WalletKeys, {
  getWalletData: ({
  reqConfig,
  }: {
    reqConfig?: AxiosRequestConfig,
  }) => ({
    queryKey: ['get-wallet-data'],
    queryFn: (): Promise<IWalletDataRes> => getWalletDataService({ reqConfig }),
  }),
});
